/* global Swiper */

document.querySelectorAll( '.b-image-buttons' ).forEach( ( block ) => {

	if ( block.classList.contains( 'is-carousel' ) ) {

		const slider = block.querySelector( '.swiper' )
		let swiperBreakpoints = {};
		const nextEl = block.querySelector( '.b-image-buttons__control--next' )
		const prevEl = block.querySelector( '.b-image-buttons__control--prev' )


		if ( slider && nextEl && prevEl ) {

			swiperBreakpoints = {
				768: {
					spaceBetween: 32,
				}
			}
			new Swiper( slider, {
				speed: 6000,
				autoplay: {
					delay: 0,
				},
				loop: true,
				watchOverflow: true,
				slidesPerView: 'auto',
				spaceBetween: 16,
				navigation: {
					nextEl: nextEl,
					prevEl: prevEl,
					disabledClass: 'b-image-buttons__control--disabled',
				},
				breakpoints: swiperBreakpoints,
				on: {
					lock: () => {

						block.querySelector( '.b-image-buttons-slides' ).classList.add( 'disable-slider' );

					},
					unlock: () => {

						block.querySelector( '.b-image-buttons-slides' ).classList.remove( 'disable-slider' );

					},

				}

			} );

		}

	}

} );

